module.exports = __webpack_public_path__ + "media/ca_slide26_sweep_fresadora.0077a9bd.mp4";